export default "__VITE_PUBLIC_ASSET__b685f765__"